import { View } from "react-native";
import React from "react";
import { Text } from "@ui-kitten/components";
import useAuth from "hooks/useAuth";
import AuthenticatedFlow from "./AuthenticatedFlow";
import LoginOrSignupForm from "components/LoginOrSignupForm";
import Container from "components/Container";
import { CliamGiftScreenProps } from "navigation/types";
import { useFetchGiftDetailsQuery } from "queries/account.queries";
import Footer from "components/Footer";
import RenderHtml from "components/RenderHtml";
import Header from "components/Header";
import TenantLogo from "components/TenantLogo";

const BuyGift = (props: CliamGiftScreenProps) => {
  const { isLoggedIn } = useAuth();
  const {
    route: {
      params: { code },
    },
  } = props;
  const { data: giftDetails } = useFetchGiftDetailsQuery(code);

  return (
    <View className="flex-1">
      <Header />
      <Container className="flex-grow items-center">
        <View className="max-w-3xl w-full">
          <View className="items-center">
            <TenantLogo width={125} height={125} />
          </View>
          {giftDetails && (
            <View className="mt-4">
              <Text category="h6">Claim Your Gift</Text>
              <View className="p-4">
                <View>
                  <Text category="s1">{giftDetails!.planPackage.name}</Text>
                  <Text>Quantity: {giftDetails!.quantity}</Text>
                  <RenderHtml
                    source={giftDetails.planPackage.description}
                  ></RenderHtml>
                </View>
              </View>
            </View>
          )}
          <View className="mt-4">
            {isLoggedIn ? (
              <AuthenticatedFlow code={code} />
            ) : (
              <LoginOrSignupForm
                loginTitle="Must log in to claim gift"
                signupTitle="Create an account to claim gift"
                initialForm="signup"
              />
            )}
          </View>
        </View>
      </Container>
      <Footer />
    </View>
  );
};

export default BuyGift;
